import EventManage from './EventManage';

export default EventManage;
